// removed by extract-text-webpack-plugin
module.exports = {"block":"_3Bxl34udV_FFcjJ0LrRWt_","header":"_1XfLQvcG61snZNxfAfLyo6","content":"bY8U0PQUSviKP6ixW-nbh","dropdown-block":"_5ojbXTyMcmmlN-YBss9ld","list":"_3k6krx_7uNDfl5L-O6uI7v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VacanciesFilter/VacanciesFilter.module.scss
// module id = 813
// module chunks = 0